import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createBlock(_component_Multiselect, {
    class: "multiselect-suppliers",
    mode: "multiple",
    "value-prop": "id",
    hideSelected: false,
    searchable: true,
    options: _ctx.suppliers,
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    "can-clear": true,
    multipleLabel: function (value) {
      return `${value.length} leverandør${value.length > 1 ? 'er':''} valgt`;
    },
    closeOnSelect: true
  }, null, 8, ["options", "modelValue", "multipleLabel"]))
}